<nav>
  <ul>
    <li>
      <a [routerLink]="['/home']" [routerLinkActive]="['active']">Home</a>
    </li>
    <li>
      <a [routerLink]="['/prompts']" [routerLinkActive]="['active']">Prompts</a>
    </li>
    <li>
      <a [routerLink]="['/audit-log']" [routerLinkActive]="['active']">Audit Log</a>
    </li>
    <li>
      <a [routerLink]="['/contact']" [routerLinkActive]="['active']">Contact us</a>
    </li>
  </ul>
</nav>
